export const LOG_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSS';

export enum LogType {
  Connected = 'Connected',
  RawBffAxiosRequest = 'RawBffAxiosRequest',
  RawBffAxiosResponse = 'RawBffAxiosResponse',
  RawBffAxiosRequestError = 'RawBffAxiosRequestError',
  RawBffAxiosResponseError = 'RawBffAxiosResponseError',
  AxiosRequest = 'AxiosRequest',
  KakaoRequest = 'KakaoRequest',
  AxiosResponse = 'AxiosResponse',
  KakaoResponse = 'KakaoResponse',
  AxiosRequestError = 'AxiosRequestError',
  KakaoRequestError = 'KakaoRequestError',
  AxiosResponseError = 'AxiosResponseError',
  KakaoResponseError = 'KakaoResponseError',
  ApiRequest = 'ApiRequest',
  ApiResponse = 'ApiResponse',
  ApiResponseError = 'ApiResponseError',
  TckRequest = 'TckRequest',
  TckResponse = 'TckResponse',
  TckRequestError = 'TckRequestError',
  TckResponseError = 'TckResponseError',
  GraphQlRequest = 'GraphQlRequest',
  GraphQlResponse = 'GraphQlResponse',
  GraphQlRequestError = 'GraphQlRequestError',
  GraphQlResponseError = 'GraphQlResponseError',
  AccessLog = 'AccessLog',
  Common = 'Common',
  Error = 'Error',
}

export const BFF_LOGGING_TYPES = [
  LogType.KakaoRequest,
  LogType.KakaoResponse,
  LogType.AxiosRequest,
  LogType.AxiosRequestError,
  LogType.AxiosResponse,
  LogType.AxiosResponseError,
  LogType.ApiRequest,
  LogType.ApiResponse,
  LogType.ApiResponseError,
  LogType.TckRequest,
  LogType.TckResponse,
];

export const ERROR_LOG_TYPES = [
  LogType.AxiosRequestError,
  LogType.AxiosResponseError,
  LogType.KakaoRequestError,
  LogType.KakaoResponseError,
  LogType.TckRequestError,
  LogType.TckResponseError,
  LogType.GraphQlRequestError,
  LogType.GraphQlResponseError,
  LogType.Error,
];
